import {AxiosResponse} from "axios";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {SNIPPETS_QUERY_KEY} from "../queryKeys";
import {ReachSnippet} from "./types";

type Variables = {};

const getSnippets = async (): Promise<ReachSnippet[]> => {
  const response = await axiosReachInstance.get<ReachSnippet[], AxiosResponse<ReachSnippet[]>>("/snippets");
  return response.data;
};

export const useGetSnippets = (
  variables: Variables = {},
  options?: BaseQueryOptions<ReachSnippet[], Variables>
): BaseUseQueryResult<ReachSnippet[]> => {
  return useBaseQuery<ReachSnippet[], Variables>([SNIPPETS_QUERY_KEY], getSnippets, variables, options);
};
